var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view_box",class:_vm.isAni ? 'ani':''},[_c('div',{staticClass:"title"},[_vm._v("拉新Tips")]),_c('div',{staticClass:"text_font"},[_vm._v("首购权益刺激-加速首购转化")])])
}
var staticRenderFns = []

export { render, staticRenderFns }